import { defineReceiver, defineCommand } from '@drapejs/invoker';
import { gql } from 'graphql-request';
import { request, query, batch } from '@motillo/drapejs-litium';
import { onMounted } from 'vue';
import { Chat } from '@/components/aixia/interfaces/AixiaTypes';

export const commands = {
    sendMessage: defineCommand<{
        url: String;
        chat: Chat;
    }>('aixia'),
    resetChat: defineCommand<
    {
        url: String;
        chat: Chat;
    }>('resetChat'),
};

export const receivers = {
    sendMessage: defineReceiver(
        commands.sendMessage,
        async function (command, data) {
            const result = await request(
                this.cache,
                query(gql`
                    mutation sendMessage($chat: ChatInput!, $url: String!){
                        session(url: $url) {
                            sendMessage {
                            chat(chat: $chat) {
                                chat {
                                    id
                                    ended
                                    language
                                    chatMessages {
                                        icon
                                        message
                                        sender
                                    }
                                    autofills {
                                        text
                                        icon
                                        color
                                    }
                                }
                            }
                            }
                        }
                    }
                `),
                {
                    url: `${(<any>command).protocol}//${(<any>command).host}${(<any>command).path}`,
                    chat: command.chat,
                }
            );
            
            return result.data;
        },
        'litium'
    ),
    resetChat: defineReceiver(
        commands.resetChat,
        async function (command, data) {
            const result = await request(
                this.cache,
                query(gql`
                    mutation resetChat($chat: ChatInput!, $url: String!){
                        session(url: $url) {
                            resetChat {
                                chat(chat: $chat) {
                                    chat {
                                        language
                                        id
                                        ended
                                        chatMessages {
                                            sender
                                            message
                                            icon
                                        }
                                        autofills {
                                            text
                                            icon
                                            color
                                        }
                                    }
                                }
                            }
                        }
                    }
                `),
                {
                    url: `${(<any>command).protocol}//${(<any>command).host}${(<any>command).path}`,
                    chat: command.chat,
                }
            );

            return result.data;
        },
        'litium'
    ),
};

onMounted